import { Box, Chip, IconButton, Stack, Typography } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import dayjs from 'dayjs';
import isEqual from 'lodash/isEqual';
import React, { FC, memo, useCallback } from 'react';
import { connect } from 'react-redux';
import CustomDataGrid, { CellWrapper } from 'src/components/DataGrid';
import { getInboxViewDataInboxes } from 'src/routes/Inbox/store/inboxViewSlice';
import {
  InboxItem,
  InboxStatus,
} from 'src/routes/Inbox/store/inboxViewSlice/types';
import { RootState } from 'src/store';
import AddIcon from '@mui/icons-material/Add';

const columns: GridColDef<InboxItem[][number]>[] = [
  {
    field: 'status',
    headerName: 'סטאטוס',
    align: 'left',
    headerAlign: 'left',
    width: 100,
    renderCell: ({ value }) => (
      <Stack
        direction="row"
        gap={1}
        height="100%"
        width="100%"
        alignItems="center"
        justifyContent="flex-start"
      >
        <Box
          style={{
            width: 10,
            height: 10,
            borderRadius: '50%',
            backgroundColor:
              value === InboxStatus.Active ? 'lightgreen' : 'red',
          }}
        />
        <Typography variant="body1" color="text.primary" fontWeight={600}>
          {value === InboxStatus.Active ? 'פעיל' : 'לא פעיל'}
        </Typography>
      </Stack>
    ),
  },
  {
    field: 'source',
    headerName: 'מקור',
    align: 'left',
    headerAlign: 'left',
    width: 50,
    renderCell: ({ value }) => (
      <CellWrapper gap={0.5}>
        <Box component="img" src={value.img} width={24} height={24} />
      </CellWrapper>
    ),
  },
  {
    field: 'address',
    headerName: 'כתובת',
    align: 'left',
    headerAlign: 'left',
    width: 250,
    renderCell: ({ value }) => (
      <CellWrapper>
        <Typography variant="body1" color="text.primary" fontWeight={600}>
          {value as string}
        </Typography>
      </CellWrapper>
    ),
  },
  {
    field: 'creation_date',
    headerName: 'תאריך יצירה',
    align: 'left',
    headerAlign: 'left',
    width: 100,
    renderCell: ({ value }) => (
      <CellWrapper>
        <Typography variant="body1" color="text.primary" fontWeight={600}>
          {dayjs(value as string).format('DD/MM/YYYY')}
        </Typography>
      </CellWrapper>
    ),
  },
  {
    field: 'last_sync_date',
    headerName: 'סנכרון אחרון',
    align: 'left',
    headerAlign: 'left',
    width: 100,
    renderCell: ({ value }) => (
      <CellWrapper>
        <Typography variant="body1" color="text.primary" fontWeight={600}>
          {dayjs(value as string).format('DD/MM/YYYY')}
        </Typography>
      </CellWrapper>
    ),
  },
  {
    field: 'receipts_count',
    headerName: 'חשבוניות',
    align: 'left',
    headerAlign: 'left',
    width: 85,
    renderCell: ({ value }) => (
      <CellWrapper>
        <Typography variant="body1" color="text.primary" fontWeight={600}>
          {(value as number).toLocaleString()}
        </Typography>
      </CellWrapper>
    ),
  },
  {
    field: 'tags',
    headerName: 'תגיות',
    align: 'left',
    headerAlign: 'left',
    width: 150,
    renderCell: ({ value }) => (
      <Stack
        direction="row"
        gap={0.5}
        width="100%"
        height="100%"
        alignItems="center"
        justifyContent="center"
      >
        {(value as string[]).map((tag) => (
          <Chip key={tag} label={tag} size="small" color="default" clickable />
        ))}
        <IconButton size="small" color="primary" onClick={() => {}}>
          <AddIcon sx={{ width: 16, height: 16 }} />
        </IconButton>
      </Stack>
    ),
  },
];

type Props = ReturnType<typeof mapStateToProps>;

const InboxResults: FC<Props> = ({ inboxes }) => {
  const handleActionClick = useCallback((id: string | number) => {
    console.log('Action clicked for inbox:', id);
    // Add your action handling logic here
  }, []);

  return (
    <CustomDataGrid
      rows={inboxes ?? []}
      columns={columns}
      withActionsMenu
      onActionClick={handleActionClick}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  inboxes: getInboxViewDataInboxes(state),
});

export default connect(mapStateToProps)(memo(InboxResults, isEqual));
